import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import MarketingPublicNav from '../components/MarketingPublicNav';
import { PublicBandSection, PublicMarketingLayout } from '../components/PublicMarketingLayout';

const Careers: React.FC = () => {
  const openPositions = [
    {
      id: 1,
      title: 'Senior Frontend Engineer',
      department: 'Engineering',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time'
    },
    {
      id: 2,
      title: 'Backend Engineer',
      department: 'Engineering',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time'
    },
    {
      id: 3,
      title: 'Product Manager',
      department: 'Product',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time'
    },
    {
      id: 4,
      title: 'Marketing Manager',
      department: 'Marketing',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time'
    },
    {
      id: 5,
      title: 'KOL Partnership Manager',
      department: 'Partnerships',
      location: 'Kuala Lumpur, Malaysia',
      type: 'Full-time'
    }
  ];

  const benefits = [
    { icon: '💰', title: 'Competitive Salary', description: 'We offer market-leading compensation packages' },
    { icon: '🏥', title: 'Health Insurance', description: 'Comprehensive health coverage for you and family' },
    { icon: '📚', title: 'Learning Budget', description: 'Annual budget for courses, books, and conferences' },
    { icon: '🏖️', title: 'Flexible PTO', description: 'Unlimited paid time off policy' },
    { icon: '🚀', title: 'Growth Opportunities', description: 'Clear career progression paths' },
    { icon: '🤝', title: 'Great Culture', description: 'Collaborative and innovative team environment' }
  ];

  return (
    <PublicMarketingLayout>
      <MarketingPublicNav />

      <PublicBandSection band={1} className="px-6 py-20">
        <div className="mx-auto max-w-6xl text-center">
          <h1 className="mb-6 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-5xl font-bold text-transparent md:text-6xl">
            Join Our Team
          </h1>
          <p className="mx-auto mb-8 max-w-4xl text-xl leading-relaxed text-gray-400 md:text-2xl">
            We're building the future of influencer marketing in Southeast Asia. Come be part of our mission!
          </p>
          <Link
            to="#positions"
            className="inline-block rounded-lg bg-white px-8 py-4 text-lg font-semibold text-violet-600 transition-colors hover:bg-gray-100"
          >
            View Open Positions
          </Link>
        </div>
      </PublicBandSection>

      <PublicBandSection band={2} className="px-6 py-16">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-transparent">Why Join kol.my?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white/5 border border-white/10 rounded-xl p-6 text-center">
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-white">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </PublicBandSection>

      <PublicBandSection id="positions" band={3} className="px-6 py-16">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-4xl font-bold text-center mb-12 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-transparent">Open Positions</h2>
          <div className="space-y-4">
            {openPositions.map((position) => (
              <div key={position.id} className="bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div>
                    <h3 className="text-xl font-bold text-white">{position.title}</h3>
                    <p className="text-gray-400">{position.department} • {position.location}</p>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="px-4 py-2 bg-violet-500/20 text-violet-400 rounded-full text-sm">{position.type}</span>
                    <button className="px-6 py-2 bg-gradient-to-r from-violet-600 to-blue-500 text-white rounded-lg font-semibold hover:opacity-90 transition-opacity">
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PublicBandSection>

      <PublicBandSection band={4} className="px-6 py-16">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-violet-500 to-blue-500 bg-clip-text text-transparent">Don't See Your Role?</h2>
          <p className="text-xl text-gray-400 mb-8">
            We're always looking for talented people. Send us your CV and we'll be in touch!
          </p>
          <a
            href="mailto:i@kol.my?subject=Job Application"
            className="px-8 py-4 bg-gradient-to-r from-violet-600 to-blue-500 text-white rounded-lg font-semibold text-lg hover:opacity-90 transition-opacity inline-block"
          >
            Send Your CV
          </a>
        </div>
      </PublicBandSection>

      <Footer />
    </PublicMarketingLayout>
  );
};

export default Careers;
